export const sections = [
  { id: 'hero', name: 'Home', icon: '🏠' },
  { id: 'about', name: 'My Journey', icon: '👨‍💻' },
  { id: 'projects', name: 'Project', icon: '🚀' },
  { id: 'certifications', name: 'Certification', icon: '🏆' },
  { id: 'testimonials', name: 'Testimonial', icon: '💬' },
  { id: 'appeal', name: 'Why NTU', icon: '🎯' },
  { id: 'contact', name: 'End', icon: '📧' }
];

export const timelineData = [
  {
    year: "2021",
    title: "Started Programming Journey",
    description: "Discovered my passion for coding through simple self-taught Python projects",
    icon: "💻",
    color: "blue"
  },
  {
    year: "2022-2025",
    title: "Singapore Polytechnic",
    description: "Diploma in Information Technology | GPA: 3.73/4.0",
    icon: "🎓",
    color: "green"
  },
  {
    year: "2024-2025",
    title: "Full Stack Developer Intern @Mercedes",
    description: "Developed middleware and full-stack application for 5000+ users",
    icon: "🚀",
    color: "purple"
  },
  {
    year: "2025",
    title: "Ready for NTU (Hopefully)",
    description: "NTU computer science is the best place for me to keep growing",
    icon: "⭐",
    color: "red"
  }
];

export const projects = [
  {
    title: "PeerPoint",
    description: "Project Management Platform for collaborative teams",
    image: "👥",
    tech: ["React", "Node.js", "MongoDB", "Socket.io"],
    challenge: "Building real-time collaboration features and intuitive project tracking",
    link: "https://devpost.com/software/peerpoint"
  },
  {
    title: "Wildlife Sighting API",
    description: "RESTful API for wildlife conservation and tracking",
    image: "🦅",
    tech: ["Python", "FastAPI", "PostgreSQL", "Docker"],
    challenge: "Working with a new api called BlackbirdAPI to integrate it with our database",
    link: "https://devpost.com/software/api-dpc6j7"
  },
  {
    title: "Immersive Wildlife Simulation",
    description: "Interactive 3D simulation for wildlife education",
    image: "🌿",
    tech: ["Unity","Blender", "C#"],
    challenge: "Coming up with realistic features within the limitations",
    link: "https://devpost.com/software/immersive-wildlife-simulation"
  }
];

export const typewriterTexts = [
  "Aspiring Developer",
  "Fearless Learner", 
  "NTU Hopeful",
  "Future Innovator"
];